import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../modules/utils/constants/constants';

export const StyledGroupDiningComponent = styled.div`
  .property-card__subTitle {
    display: -webkit-box;
    max-width: 100%;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }

  .property-card__eyebrow {
    padding-bottom: ${toRem(8)};
  }

  .culinary-view-separator,
  .separator {
    border-top: ${toRem(1)} solid ${baseVariables.color.neutral20} !important;
    margin-top: ${toRem(48)} !important;
    margin-bottom: ${toRem(16)} !important ;
  }

  .reserve-culinary-link {
    color: ${baseVariables.color.merch30} !important;
    border-bottom: 1px solid;
    &::after {
      content: none !important;
    }
  }

  .property-card {
    height: auto;
    @media ${baseVariables.mediaQuery.md} {
      height: ${toRem(395)};
      .property-card__img-container,
      .property-card__img-container--img {
        height: ${toRem(395)};
      }
    }
    .property-card__img-container--ribbon {
      .ribbons-container {
        .ribbon {
          width: max-content;
        }
      }
    }
  }

  .property-card__details-container_desc {
    display: -webkit-box;
    -webkit-line-clamp: 3 !important;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: ${toRem(16)} !important;

    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: ${toRem(24)} !important;
    }
  }

  .property-card__details-container {
    height: calc(100% - 50%);
  }

  .property-card__img-container {
    img {
      border-radius: ${toRem(14)} 0 0;
    }
  }

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    .property-card__details-container {
      height: inherit;
    }
  }

  .property-card__details-container {
    padding-top: ${toRem(16)} !important;
    padding-bottom: ${toRem(16)} !important;
  }

  .group-dining {
    &__header {
      display: flex;
      flex-direction: column;
      gap: var(--General-spacer-02, ${toRem(8)});

      @media ${baseVariables.mediaQuery.md} {
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
      }
    }

    &__title-block {
      display: flex;
      flex-direction: column;
      gap: var(--General-spacer-02, ${toRem(8)});
    }

    &__footer {
      display: flex;
      justify-content: center;
      margin-top: var(--General-spacer-06, ${toRem(48)});
    }
  }

  &:is(${constants.RTL_LANG_LIST}) {
    .group-dining__filter-row {
      ${rtl`flex-direction: row-reverse;`}
    }
  }

  .carouselControlType2 .left-arrow {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0;
  }

  .carouselControlType2 .right-arrow {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0;
  }

  .w-100 {
    width: 100%;
  }
`;
